<template>
  <v-main>
    <v-app-bar app color="primary" dark>
      <v-btn icon @click.stop="backButton()">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title>Изменение дня</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="editDay()" :disabled="!formValid" v-on="on">
            <v-icon>mdi-check</v-icon>
          </v-btn>
        </template>
        <span>Сохранить</span>
      </v-tooltip>
    </v-app-bar>
    <v-container>
      <v-row justify="center">
        <v-col xl="5" lg="7" md="9" sm="11">
          <v-form lazy-validation ref="dayForm" v-model="formValid">
            <p>День: {{ obj.id }}</p>
            <v-textarea label="В плюсе"
              v-model.trim="obj.in_plus"
              auto-grow
              :rules="[v => !!v || 'Пожалуйста, заполните это поле']">
            </v-textarea>
            <v-textarea label="В минусе"
              v-model.trim="obj.in_minus"
              auto-grow
              :rules="[v => !!v || 'Пожалуйста, заполните это поле']">
            </v-textarea>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  data () {
    return {
      obj: {},
      formValid: false
    }
  },
  methods: {
    backButton: function () {
      this.$store.commit('DAYS_CLEAN')
      this.$router.go(-1)
    },
    editDay: function () {
      if (this.$refs.dayForm.validate()) {
        this.$store.dispatch('DAYS_UPDATE', this.obj).then(() => {
          if (this.$store.getters.daysStatus === 'success') {
            this.$store.commit('SNACKBAR_SET', 'Сохранено успешно')
            this.backButton()
          }
        }, (err) => {
          this.$store.commit('SNACKBAR_SET', 'При сохранении произошла ошибка.' + err)
          this.backButton()
        })
      }
    },
    getDay: function () {
      this.$store.dispatch('DAYS_GET_DAY', this.$store.getters.day).then(() => {
        if (this.$store.getters.daysStatus === 'success') {
          this.obj = this.$store.getters.day
        } else {
          this.$store.commit('SNACKBAR_SET', 'Ошибка загрузки')
          this.backButton()
        }
      }, (err) => {
        err = ''
        this.$store.commit('SNACKBAR_SET', 'Ошибка загрузки' + err)
        this.backButton()
      })
    }
  },
  mounted: function () {
    try {
      this.obj = this.$store.getters.day
      if (this.obj.id !== null) this.getDay()
    } catch (e) {
      this.backButton()
    }
  }
}
</script>

<style scoped>

</style>
